import { motion } from 'framer-motion'
import { styled } from 'styled-components'

import { IconArrow } from 'components/icons/arrow'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { typography } from 'styles/typography'
import { resetButtonStyle } from 'styles/utils'

export const Image1 = styled(motion.div)`
  display: block;
  order: -1;
  width: max-content;
  max-width: 100%;

  ${mq.smallOnly} {
    overflow: hidden;
  }

  ${mq.medium} {
    position: absolute;
    top: 0;
  }
`

export const Image1a = styled(motion.img)`
  display: block;
  width: 100vw;

  ${mq.smallOnly} {
    max-width: 40rem;
  }

  ${mq.medium} {
    width: auto;
    height: 8vmax;
  }
`

export const Image1b = styled(Image1a)`
  margin-left: 10%;

  ${mq.medium} {
    height: 4.5vmax;
  }
`

export const Image2 = styled(Image1a)`
  display: none;
  position: absolute;
  right: 0;
  width: 40%;

  ${mq.medium} {
    display: block;
    top: auto;
    bottom: 0;
    width: 40%;
    height: auto;
  }

  ${mq.large} {
    bottom: auto;
    width: calc((100vw - var(--text-width)) / 2 - 5rem);
  }
`

export const Image3 = styled(Image1)`
  display: flex;
  order: unset;

  ${mq.ltLarge} {
    position: relative;
    top: auto;
    width: 40%;
  }

  ${mq.smallOnly} {
    width: calc(100% - 4rem);
    left: 2rem;
  }

  ${mq.large} {
    top: calc(100% - 20vmax);
    width: calc((100vw - var(--text-width)) / 2);
  }
`

export const Image3a = styled(Image1a)`
  width: ${10400 / 368}%;
  height: auto;

  ${mq.large} {
    margin-block: -10% -50%;
  }
`

export const Image3b = styled(Image3a)`
  width: ${9300 / 368}%;
`

export const Image3c = styled(Image3a)`
  width: 100%;
`

export const Picture = styled(Image3a).attrs({ as: 'picture' })`
  width: ${17100 / 368}%;

  ${mq.smallOnly} {
    width: ${17000 / 368}%;
  }
`

export const Header = styled(motion.header)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100svh - var(--header-height));
  --text-width: 100%;

  ${mq.medium} {
    --text-width: min(70vw, 45em);

    padding-block-start: 13vmax;
  }

  ${mq.large} {
    padding-block: 13vmax;
  }
`

export const TextContent = styled.div`
  margin: auto;
  padding-block: 3rem;
  width: max-content;
  max-width: 100%;
`

export const Left = styled.span`
  display: block;
  padding-inline: 0.5rem;
  margin-inline-end: -0.2em;
  background-color: var(--background);
`

export const Right = styled.span`
  display: block;
  text-align: right;
  width: min-content;
  margin-inline: auto -0.2em;
  padding-inline: 0.5rem;
  background-color: var(--background);
`

export const Title = styled(motion.h1)`
  ${typography.heading.h1}
  display: block;
  position: relative;
  width: min-content;
  margin: 0 auto;
  z-index: 1;

  > span {
    display: block;
    position: relative;
    background-color: var(--background);

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: 0;
      border-top: 1px solid currentColor;
      width: calc(100% + 50vw);
      z-index: -1;
    }
  }

  > span:has(${Right}) {
    background-color: transparent;
  }
`

export const Small = styled(motion.span)`
  display: block;
  font-size: 50%;
  font-weight: 200;
  line-height: 1.2;
`

export const IntroText = styled(motion.div)`
  ${typography.text.md}
  position: relative;
  width: var(--text-width);
  padding-inline: 2rem;
  margin: 2em auto 0;
  text-align: justify;
  hyphens: auto;
  z-index: 1;

  ${mq.medium} {
    padding-inline: 3rem;
  }
`

export const ScrollButton = styled.button.attrs({ type: 'button' })`
  ${resetButtonStyle}
  position: sticky;
  bottom: 3rem;
  width: max-content;
  margin: 0 auto;
  padding: 0.5rem;
  color: var(--primary-color);
  cursor: pointer;
  background-color: var(--background);
  z-index: 1;

  &,
  &:focus-visible {
    border-radius: 50%;
  }

  ${mq.smallOnly} {
    margin-block-start: 3rem;
  }
`

export const StyledIconArrow = styled(IconArrow)`
  display: block;
  font-size: 4.8rem;
  transform: rotate(-90deg);
  transition: transform 0.5s cubic-bezier(${theme.ease.out.join(', ')});

  ${ScrollButton}:hover & {
    transform: translateY(1rem) rotate(-90deg);
  }
`
